const session = {
    not_found: '未找到会话。请返回并重新登录。',
    invalid_credentials: '账号或密码错误，请重新输入。',
    invalid_sign_in_method: '当前登录方式不可用',
    invalid_connector_id: '找不到标识为 {{connectorId}} 的可用连接器。',
    insufficient_info: '登录信息缺失，请检查你的输入。',
    connector_id_mismatch: '传入的连接器标识与会话中保存的记录不一致',
    connector_session_not_found: '无法找到连接器登录信息，请尝试重新登录。',
    verification_session_not_found: '验证失败，请重新验证。',
    verification_expired: '当前页面已超时。为确保你的账号安全，请重新验证。',
    verification_blocked_too_many_attempts: '尝试次数过多。请稍后再试 {{relativeTime}}。',
    unauthorized: '请先登录',
    unsupported_prompt_name: '不支持的提示参数名称（prompt name）',
    forgot_password_not_enabled: '忘记密码功能没有开启。',
    verification_failed: '验证失败，请重新验证。',
    connector_validation_session_not_found: '找不到连接器用于验证令牌的信息。',
    csrf_token_mismatch: '跨站请求伪造（CSRF）令牌不匹配。',
    identifier_not_found: '找不到用户标识符。请返回并重新登录。',
    interaction_not_found: '找不到交互会话。请返回并重新开始会话。',
    invalid_interaction_type: '此操作不支持当前交互。请启动一个新会话。',
    not_supported_for_forgot_password: '此操作不支持忘记密码。',
    identity_conflict: '检测到身份不匹配。请启动一个新会话以使用不同的身份进行操作。',
    identifier_not_verified: '提供的标识符 {{identifier}} 尚未经过验证。请为此标识符创建验证记录并完成验证过程。',
    mfa: {
        require_mfa_verification: '需要多因素身份验证(MFA)才能登录。',
        mfa_sign_in_only: '多因素身份验证(MFA)仅适用于登录交互。',
        pending_info_not_found: '找不到待处理的多因素身份验证(MFA)信息，请先启动多因素认证。',
        invalid_totp_code: '无效的基于时间的一次性密码（TOTP）代码。',
        webauthn_verification_failed: '网络身份验证（WebAuthn）验证失败。',
        webauthn_verification_not_found: '未找到网络身份验证（WebAuthn）验证。',
        bind_mfa_existed: '多因素身份验证(MFA)已存在。',
        backup_code_can_not_be_alone: '备用代码不能是唯一的多因素认证。',
        backup_code_required: '需要备用代码。',
        invalid_backup_code: '无效的备用代码。',
        mfa_policy_not_user_controlled: '多因素认证策略不受用户控制。',
        mfa_factor_not_enabled: '多因素认证因素未启用。',
        suggest_additional_mfa: '为更强的安全性，建议添加另一种多因素认证方式。你可以跳过此步骤继续。',
    },
    passkey_sign_in: {
        pending_info_not_found: '未找到待处理的通行密钥登录信息。请重新发起登录流程。',
        conflict_rp_id: '依赖方标识不匹配。请使用正确的客户端登录。',
        sso_users_not_allowed: '单点登录用户无法使用通行密钥登录选项。',
    },
    password_expiration: {
        reset_not_allowed: '只有在当前登录会话中的密码过期后，才允许重置密码。',
    },
    sso_enabled: '该邮箱已开启单点登录，请使用单点登录登录。',
    captcha_required: '需要验证码。',
    captcha_failed: '验证码验证失败。',
    email_blocklist: {
        disposable_email_validation_failed: '电子邮件地址验证失败。',
        invalid_email: '无效的电子邮件地址。',
        email_subaddressing_not_allowed: '不允许电子邮件子地址。',
        email_not_allowed: '电子邮件地址 "{{email}}" 受限。请选择其他地址。',
    },
    google_one_tap: {
        cookie_mismatch: 'Google One Tap浏览器存储数据不匹配。',
        invalid_id_token: '无效的Google身份令牌。',
        unverified_email: '邮箱未验证。',
    },
};
export default Object.freeze(session);
